export default __webpack_public_path__ + "static/backgroundHome-add3961def3ff51d55ec42c8a8890e80.png";